exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tippy-tooltip[data-v-dab9bdd2]{background-color:#fff;padding:0;-webkit-box-shadow:0 2px 16px 0 rgba(55,63,71,.15);box-shadow:0 2px 16px 0 rgba(55,63,71,.15)}.tippy-tooltip .tippy-content[data-v-dab9bdd2]{position:relative;color:#444;border-radius:.25rem;font-size:.875rem;padding:24px;line-height:1.4;text-align:left}.tippy-popper[x-placement^=right] .tippy-arrow[data-v-dab9bdd2]{border-right:8px solid #fff}.tippy-popper[x-placement^=bottom] .tippy-arrow[data-v-dab9bdd2]{border-bottom:8px solid #fff}.loader-wrap[data-v-dab9bdd2]{margin:80px 0 120px;text-align:center}", ""]);

// exports
